import script from "./CInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CInput.vue?vue&type=script&setup=true&lang=ts"

import "./CInput.vue?vue&type=style&index=0&id=783912a2&lang=scss&scoped=true"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783912a2"]])

export default __exports__